export default "__VITE_PUBLIC_ASSET__5574fb29__"